import React from 'react';
import Icon from './Icon';

/**
 * Admin list selection checkbox toggle.
 * @param {boolean} checked - selected state
 * @param {function} onClick - click handler (should call e.stopPropagation() if inside clickable card)
 * @param {'sm'|'md'} size - sm = 20px, md = 24px
 * @param {string} className - additional classes (e.g. 'mt-0.5')
 */
export default function SelectionCheckbox({ checked, onClick, size = 'sm', className = '' }) {
  const sizeClass = size === 'md' ? 'w-6 h-6' : 'w-5 h-5';
  const iconSize = size === 'md' ? 14 : 12;

  return (
    <button
      type="button"
      onClick={onClick}
      className={`${sizeClass} rounded border-2 flex items-center justify-center shrink-0 transition-colors ${
        checked ? 'bg-mono-900 border-mono-900' : 'border-mono-300 hover:border-mono-500'
      } ${className}`}
    >
      {checked && <Icon name="check" size={iconSize} className="text-white" />}
    </button>
  );
}
